import PromoCard from './PromoCard';

export * from './types';
export default PromoCard;
